import { APIObject } from "@/services/api/types";

export enum PartnerColumn {
  NAME = "name",
  TYPE = "type",
  STATUS = "status",
  PARENT_PARTNER = "parentPartner",
  WEBSITE = "website",
  PHONE = "phone",
  COUNTRY = "country",
  STATE_REGION = "stateRegion",
  CITY = "city",
  POSTAL_CODE = "postalCode",
  ADDRESS = "address",
  AREA_OF_RESPONSIBILITY = "areaOfResponsibility",
  CREATED_AT = "createdAt"
}

// The object tabs on the partner detail page that scope another entity's table
// to the partner, and so share empty-state and link-modal wiring.
export type PartnerTab = "deals" | "leads";

export enum PartnerStatus {
  ONBOARDING = 1,
  ACTIVE,
  INACTIVE
}

interface PartnerData extends APIObject {
  name: string;
  // partners_types ids; labels come from the `type` field's config.options.
  type: number[] | null;
  status: PartnerStatus;
  parentPartner: string | null;
  website: string | null;
  phoneNumber: string | null;
  country: string | null;
  stateRegion: string | null;
  city: string | null;
  postalCode: string | null;
  address: string | null;
  areaOfResponsibility: string | null;
  openDealsCount?: number | null;
  openLeadsCount?: number | null;
  createdAt: string | null;
}

interface PartnersPage {
  partners: PartnerData[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export type { PartnerData, PartnersPage };
